module.exports = __webpack_public_path__ + "img/wenskaarten-kerstkaarten-kerst-papette-quotes-5.31c4789d.jpg";